import React from 'react';
import PropTypes from 'prop-types';
import ComponentsFactory from 'foundation/components-factory';
import { ContentType } from 'components/content-type';
import { mediaTypes } from 'components/posts';

class PlayerCard extends React.Component {
    constructor(props) {
        super(props);

        this.rootRef = React.createRef();
    }

    componentDidMount() {
        ComponentsFactory.getInstance().init(this.rootRef.current);
    }

    componentWillUnmount() {
        ComponentsFactory.getInstance().destroy(this.rootRef.current);
    }

    onClickRoot = () => {
        const { onCardLinkClick, model } = this.props;
        onCardLinkClick(model);
    }

    renderContentType(model) {
        if (model.type === mediaTypes.GALLERY ||
            model.type === mediaTypes.VIDEO_PLAYER
        ) {
            return (
                <div className="player-card__content-type">
                    <ContentType type={model.type} />
                </div>
            );
        }

        return null;
    }

    render() {
        const { model, bemModifiers } = this.props;
        let bemCss = '';

        if (Array.isArray(bemModifiers)) {
            bemCss = bemModifiers.map((x) => `player-card--${x}`).join(' ');
        }

        return (
            <a
                className={`player-card ${bemCss}`}
                href={model.url}
                data-dc-component="modal-spa-trigger"
                ref={this.rootRef}
                onClick={this.onClickRoot}
            >
                <div className="player-card__bg">
                    <img className="lazyload" alt="" data-srcset={model.bgImage} data-sizes="auto" />
                </div>
                {
                    model.frontImage &&
                    <div className="player-card__photo">
                        <img className="lazyload" alt="" data-srcset={model.frontImage} data-size="auto" />
                    </div>
                }

                <div className="player-card__grid">
                    <div className="player-card__content">
                        <p className="player-card__label">{model.label}</p>
                        <h3 className="player-card__heading">
                            <b className="player-card__title">{model.title}</b>
                            {model.subtitle && <span className="player-card__divider">/</span>}
                            {model.subtitle && <span>{model.subtitle}</span>}
                        </h3>
                        <div className="player-card__cta">
                            <span className="player-card__cta-text">{model.ctaText}</span>
                            <svg className="player-card__cta-icon icon" width="14" height="12" focusable="false">
                                <use xlinkHref="#icon-arrow-right"></use>
                            </svg>
                        </div>
                        {this.renderContentType(model)}
                    </div>
                </div>
            </a>
        );
    }
}

PlayerCard.propTypes = {
    model: PropTypes.object.isRequired,
    bemModifiers: PropTypes.array,
    onCardLinkClick: PropTypes.func,
};

export default PlayerCard;
